// Configuración de la API
// Detectar el entorno actual - usar REACT_APP_API_URL si está definida
const isProduction = process.env.NODE_ENV === 'production' || !!process.env.REACT_APP_API_URL;

// Configurar URL base según el entorno
// Si REACT_APP_API_URL está definida, usarla. Si no, usar la URL por defecto según el entorno
const API_BASE_URL = process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL.trim()}/api/v1`
    : (process.env.NODE_ENV === 'production'
        ? 'https://fty7pwdpdx.us-east-2.awsapprunner.com/api/v1'
        : 'http://localhost:3000/api/v1');

if (isProduction) {
    console.log('✓ Entorno de producción detectado');
    console.log('✓ API Base URL:', API_BASE_URL);
} else {
    console.log('✓ Entorno de desarrollo detectado');
    console.log('✓ API Base URL:', API_BASE_URL);
}

// Configuraciones específicas por entorno
export const APP_CONFIG = {
    apiTimeout: isProduction ? 10000 : 30000,
    enableDebugLogs: !isProduction,
    environment: isProduction ? 'production' : 'development'
};

// Clave para consultas en React Query
export const QUERY_KEYS = {
    PRODUCTS: ['products'],
    CATEGORIES: ['categories'],
    MENU: ['menu'],
};

const apiConfig = {
    // URL base de la API
    baseURL: API_BASE_URL,
    endpoints: {
        products: '/products',
        categories: '/categories',
    },

    // Configuración de solicitudes
    fetchOptions: {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            // Sin token de autenticación para endpoints públicos
        },
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'omit', // Omitimos credenciales para acceder como visitante público
        timeout: APP_CONFIG.apiTimeout
    },

    // Función para obtener opciones de fetch con posibilidad de override
    getFetchOptions: (overrides = {}) => {
        return {
            ...apiConfig.fetchOptions,
            ...overrides,
            headers: {
                ...apiConfig.fetchOptions.headers,
                ...(overrides.headers || {})
            }
        };
    },

    // Función para construir URLs con parámetros
    buildUrl: (endpoint, params = {}) => {
        const url = new URL(`${apiConfig.baseURL}${endpoint}`);
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null) {
                url.searchParams.append(key, params[key]);
            }
        });
        return url.toString();
    }
};

export default apiConfig;
